module.exports = __webpack_public_path__ + "static/skills-8aa852d643b75973fa2448a9d7dbaa61.svg";